<template>
    <div class="wallet-header">
        <div class="wallet-title">
            <div :class="['wallet-back', { active: (type === 1 && route.query.back) || type === 2 }]" @click="handleBack">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="45" viewBox="0 0 26 45" fill="none">
                    <path
                        d="M24.8094 1.47487C26.1762 2.84171 26.1762 5.05779 24.8094 6.42462L8.89951 22.3345L24.8094 38.2444C26.1762 39.6113 26.1762 41.8273 24.8094 43.1942C23.4426 44.561 21.2265 44.561 19.8597 43.1942L1.47488 24.8094C0.108049 23.4426 0.108049 21.2265 1.47488 19.8596L19.8597 1.47487C21.2265 0.108039 23.4426 0.108039 24.8094 1.47487Z"
                        fill="white"
                    />
                </svg>
            </div>
            <div class="wallet-txt">{{ $t(title) }}</div>
            <div class="record" @click="handleRecoder">
                Records
                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <path
                        d="M-6.52683e-07 14.9321C-1.01315e-06 6.68558 6.68511 0.000570005 14.9316 0.000487629C23.1782 0.000487268 29.8633 6.68553 29.8633 14.9321C29.8632 23.1787 23.1782 29.8638 14.9316 29.8638C6.68516 29.8637 8.21767e-05 23.1786 -6.52683e-07 14.9321ZM10.123 4.29736C9.41984 5.00056 9.41984 6.14006 10.123 6.84326L18.3076 15.0288L10.1221 23.2144C9.41888 23.9176 9.41887 25.058 10.1221 25.7612C10.8253 26.4641 11.9658 26.4643 12.6689 25.7612L22.1279 16.3022C22.8308 15.5991 22.8308 14.4585 22.1279 13.7554L12.6689 4.29736C11.9658 3.59425 10.8263 3.59443 10.123 4.29736Z"
                        fill="white"
                    />
                </svg>
            </div>
        </div>
        <div class="wallet-money">
            <div class="money-count">{{ formatLocalMoney(wallet?.gold || 0) }}</div>
            <div v-if="type === 1" class="withdraw-icon" @click="goWithdraw">Withdraw</div>
        </div>
        <div v-if="type === 1" class="wallet-other">
            <div class="other-left">
                <span class="other-help" @click="handleShowTip"></span>
                <span class="other-title"
                    >Bonus: <span class="yellow-color">{{ formatNormalNumber(wallet?.bonus || 0) }}</span></span
                >
                <!-- 解锁bonus悬浮 -->
                <div
                    v-if="showBonusTip"
                    class="tip text-center"
                    v-html="
                        $t('bonus_tovip_info', {
                            number1: gameStoreData?.vip?.unlockRemain,
                            current_type: '',
                            number2: wallet?.bonus || 0,
                        })
                    "
                ></div>
            </div>
        </div>
        <div v-else :class="['withdraw-other', { flash: showAnimate }]" @animationend="showAnimate = false">
            <div class="other-tip">
                <span>{{ $t('wallet_bet_amount_left') }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none" @click="handleShowTip">
                    <path
                        d="M14.5 0C22.5081 0 29 6.49187 29 14.5C29 22.5081 22.5081 29 14.5 29C6.49187 29 0 22.5081 0 14.5C1.13389e-05 6.49187 6.49188 0 14.5 0ZM14.7324 20.3604C14.0922 20.3604 13.5586 20.5742 13.1318 21.001C12.7245 21.4084 12.5205 21.942 12.5205 22.6016C12.5205 23.2612 12.7244 23.8046 13.1318 24.2314C13.5586 24.6582 14.0922 24.8711 14.7324 24.8711C15.392 24.8711 15.9256 24.6582 16.333 24.2314C16.7598 23.8046 16.9736 23.2612 16.9736 22.6016C16.9736 21.9419 16.7598 21.4084 16.333 21.001C15.9256 20.5742 15.392 20.3604 14.7324 20.3604ZM15.4023 4.23828C13.4428 4.23828 11.8898 4.79061 10.7451 5.89648C9.60044 7.00237 9.00951 8.55536 8.9707 10.5537C8.97311 10.5813 9.09771 11.9166 10.7021 11.877C12.3067 11.8371 12.4312 10.5792 12.4336 10.5537C12.453 9.62257 12.6857 8.93354 13.1318 8.4873C13.578 8.0411 14.2086 7.81741 15.0234 7.81738C15.7606 7.81738 16.3328 7.99262 16.7402 8.3418C17.1477 8.67162 17.3516 9.19523 17.3516 9.91309C17.3516 10.4369 17.2447 10.8932 17.0312 11.2812C16.8373 11.6496 16.5756 11.9985 16.2461 12.3281C15.9357 12.6385 15.5961 12.9593 15.2275 13.2891C14.8784 13.6188 14.5387 13.9872 14.209 14.3945C13.8986 14.8019 13.6362 15.2772 13.4229 15.8203C13.2288 16.3636 13.1318 17.0237 13.1318 17.7998C13.1324 17.8105 13.2017 19.1643 14.8057 19.1533C16.4086 19.1422 16.4779 17.8115 16.4785 17.7998C16.4785 17.179 16.5953 16.6455 16.8281 16.1992C17.0803 15.7336 17.4001 15.3159 17.7881 14.9473C18.1761 14.5593 18.584 14.1811 19.0107 13.8125C19.4375 13.444 19.8445 13.0558 20.2324 12.6484C20.6204 12.2216 20.9312 11.7366 21.1641 11.1934C21.4162 10.6309 21.5419 9.98116 21.542 9.24414C21.542 8.15766 21.2906 7.24507 20.7861 6.50781C20.2817 5.77058 19.573 5.20833 18.6611 4.82031C17.7494 4.43236 16.6632 4.23833 15.4023 4.23828Z"
                        fill="white"
                    />
                </svg>
                <span class="yellow">{{ remainBet }}</span>
            </div>
            <div class="tip-explian">
                {{
                    $t('withdraw_turnover_requirement_info1', {
                        number: remainBet,
                    })
                }}
            </div>
        </div>
        <!-- <GeneralDialog v-model="showTip.wallet" title="Bonus">
            <div class="tip-content">
                <div
                    class="content"
                    v-html="$t('bonus_explanation', { level: vipInfo.curLevel, betrebate: formatNormalNumber(betRebate * 100) + '%' })"
                ></div>
                <div class="confirm" @click="showTip.wallet = false">{{ $t('Confirm') }}</div>
            </div>
        </GeneralDialog> -->
        <Record v-if="recordVisible" v-model="recordVisible" :type="type" />
        <Tip v-model="showTip.withDraw" :title="$t('wallet_bet_amount_left')" :content="$t('withdraw_turnover_requirement_info2', { place: '|' })" />
        <BonusTip
            v-model="showTip.wallet"
            title="Bonus"
            :content="$t('bonus_explanation', { level: vipInfo.curLevel, betrebate: formatNormalNumber(betRebate * 100) + '%' })"
        />
    </div>
</template>
<script setup lang="ts">
import { useBaseStore } from '@/stores'
import { storeToRefs } from 'pinia'

import Record from '@/components/wallet/record.vue'
import { useRouter, useRoute } from 'vue-router'
import { formatLocalMoney, formatNumber, formatNormalNumber } from '@/utils/toolsValidate'
import { Log } from '@/api/log'
import { FORMATE_CURRENCY } from '@/enums'
import { useGame } from '@/hooks/useGame'
import EventBus from '@/utils/bus'
import BonusTip from './bonusTip.vue'

const props = defineProps({
    type: {
        type: Number,
        default: () => 1,
    },
    title: {
        type: String,
        default: '',
    },
    balance: {
        type: Number,
        default: () => 0,
    },
    remainBet: {
        type: Number,
        default: () => 0,
    },
    gameStoreData: {
        type: Object,
        default: () => {
            return {
                vip: {
                    unlockRemain: 0,
                },
            }
        },
    },
})

const router = useRouter()
const route = useRoute()
const store = useBaseStore()
const { gameSubscibe } = useGame()
const { wallet, vipInfo, vipConfig } = storeToRefs(store)

// const showTip = ref(false)
const recordVisible = ref(false)

const showAnimate = ref(false)
const showTip = reactive({
    wallet: false,
    withDraw: false,
})
const showBonusTip = computed(() => {
    // 当前不在钱包页面不显示
    if (!route.path.includes('/wallets')) {
        return false
    }
    if (props.gameStoreData?.vip?.unlockRemain === 0) {
        return false
    }
    if (vipInfo.value.exp) {
        return false
    }
    if (!wallet.value?.bonus) {
        return false
    }
    return true
})

const betRebate = computed(() => {
    return vipConfig.value.find((item) => item.level === vipInfo.value.curLevel)?.betRebate || 0
})
const handleRecoder = () => {
    Log({ event: 'wallet_deposit_record' })
    recordVisible.value = true
}
const handleShowTip = () => {
    if (props.type === 1) {
        showTip.wallet = true
    } else {
        showTip.withDraw = true
    }
}

const goWithdraw = () => {
    Log({ event: 'wallet_withdraw' })
    router.push({
        path: '/cashout',
    })
}
const handleBack = async () => {
    if (route.query.from === 'game') {
        const url = await gameSubscibe(store.prevGameTag)
        router.replace({
            path: '/iframe',
            query: {
                u: encodeURIComponent(url),
                from: 'wallet',
            },
        })
    } else {
        router.back()
    }
}

const goSevice = () => {
    window.open('https://m.me/ShewinGamesPH')
}
const handleWithdrawTipAnimate = () => {
    showAnimate.value = true
}
onBeforeMount(() => {
    EventBus.on('bindWithdrawTipAnimate', handleWithdrawTipAnimate)
})
onBeforeUnmount(() => {
    EventBus.off('bindWithdrawTipAnimate', handleWithdrawTipAnimate)
})
</script>
<style lang="scss" scoped>
.wallet-header {
    box-sizing: border-box;
    padding: 86px 33px 0 10px;
    height: 450px;
    background-image: url('@/assets/img/wallets/wallet-girl.png'), url('@/assets/img/wallets/wallet_bg.jpg');
    background-repeat: no-repeat;
    background-size: 213px 298px, 100% 450px;
    background-position: -30px bottom, left bottom;
    border-radius: 0px 0px 40px 40px;

    .wallet-title {
        display: flex;
        align-items: center;
        margin-bottom: 45px;

        .wallet-txt {
            flex: 1;
            padding-left: 95px;
            line-height: 70px;
            font-size: 36px;
            font-weight: bold;
            color: #ffffff;
            text-align: center;
        }

        .wallet-back {
            width: 40px;
            height: 40px;
            svg {
                width: 100%;
                height: 100%;
            }
        }
        .wallet-back {
            opacity: 0;
            pointer-events: none;
            &.active {
                opacity: 1;
                pointer-events: all;
            }
        }
        .record {
            @apply flex items-center relative gap-[4px];
            color: #fff;
            font-size: 28px;
            font-weight: 700;

            svg {
                width: 31px;
                height: 30px;
            }
            &::after {
                position: absolute;
                bottom: 0;
                left: 0;
                content: '';
                width: 100%;
                height: 4px;
                border-radius: 10px;
                background: #fff;
            }
        }
    }

    .wallet-money {
        @apply flex items-center;
        position: relative;
        margin-left: auto;
        width: 545px;
        height: 78px;
        padding: 0 5px 0 30px;
        border-radius: 50px;
        border: 4px solid rgba(255, 255, 255, 0.16);
        background: rgba(0, 0, 0, 0.3);

        .money-count {
            flex: 1;
            color: #ffea76;
            font-size: 48px;
            font-weight: 700;
            // @apply flex justify-center items-center;
            // margin: 0 auto;
            // width: 420px;
            // height: 98px;
            // font-size: 48px;
            // font-weight: bold;
            // color: #f3d773;
            // line-height: 48px;
            // border-radius: 49px;
            // background: url('@/assets/img/wallets/w-k1.png') no-repeat;
            // background-size: 100% 100%;
        }
        .withdraw-icon {
            @apply flex justify-center items-center;
            width: 180px;
            height: 60px;
            background: url('@/assets/img/wallets/withdraw_bg.png') no-repeat;
            background-size: 100% 100%;
            color: #86311c;
            font-size: 28px;
            font-weight: 700;
        }
    }
    .wallet-other {
        display: flex;
        flex-direction: column;
        margin-top: 25px;
        width: 545px;

        .other-left {
            @apply flex items-center justify-center relative;
            width: 100%;
            line-height: 50px;

            .left-title {
                font-size: 24px;
                color: #fff;
            }

            .other-help {
                display: inline-block;
                margin-left: 20px;
                margin-right: 8px;
                width: 30px;
                height: 30px;
                background: url('@/assets/img/wallets/qestion_icon.png') no-repeat;
                background-size: 100% 100%;
            }
            .other-title {
                font-size: 30px;
                color: #ffffff;
                .yellow-color {
                    color: #ffea76;
                }
            }

            .tip {
                position: absolute;
                left: 45%;
                top: 30px;
                width: 440px;
                padding: 40px 30px 30px 46px;
                background: url('@/assets/img/wallets/di2.webp') no-repeat;
                background-size: 100% 100%;
                color: #fff;
                font-size: 26px;
                font-weight: 700;
                z-index: 10;

                :deep(span) {
                    color: #fcff1b;
                }
            }
        }
        .other-right {
            @apply flex justify-end;

            &.one {
                @apply justify-center;
            }

            .left-num {
                @apply flex justify-center items-center;
                margin-right: 20px;
                width: 300px;
                height: 60px;
                border-radius: 30px;
                background: url('@/assets/img/wallets/w-k2.png') no-repeat;
                background-size: 100% 100%;
            }
            .other-count {
                font-size: 36px;
                line-height: 30px;
                color: #ffea76;
                font-weight: bold;
            }
        }
        .wallet-record {
            position: relative;
            font-size: 30px;
            color: #ffffff;

            &::before,
            &::after {
                display: inline-block;
                content: '';
            }
            &::before {
                position: absolute;
                left: 0;
                bottom: 1px;
                width: 100%;
                height: 4px;
                background-color: #ffffff;
                border-radius: 2px;
            }
            &::after {
                position: relative;
                top: 5px;
                margin-left: 10px;
                width: 30px;
                height: 30px;
                background: url('@/assets/img/wallets/enter-arrow.png') no-repeat;
                background-size: 100% 100%;
            }
        }
    }
    .withdraw-other {
        @apply flex flex-col justify-center;
        margin: 17px 0 0 auto;
        width: 536px;
        height: 89px;
        padding: 0 20px;
        border-radius: 15px;
        border: 4px solid rgba(0, 0, 0, 0);

        .other-tip {
            @apply flex items-center;
            color: #fff;
            font-size: 30px;
            font-weight: 700;

            svg {
                margin: 0 30px 0 10px;
                width: 29px;
                height: 30px;
            }
            .yellow {
                color: #ffea76;
            }
        }
        .tip-explian {
            color: #c88bbd;
            font-size: 24px;
            font-weight: 400;
        }
        &.flash {
            animation: tipShake 1s 5 alternate;
        }
    }
}

.tip-content {
    height: 730px;
    padding: 30px 28px 60px;
    background-color: #2a2d3d;
    font-family: MicrosoftYaHei;
    color: #ffffff;

    .title {
        position: relative;
        margin-bottom: 29px;
        line-height: 99px;
        font-size: 40px;
        text-align: center;

        &::after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: 0;
            width: 620px;
            height: 4px;
            background-color: #ffffff;
            border-radius: 2px;
            opacity: 0.2;

            transform: translateX(-50%);
        }
    }
    .content {
        // flex: 1;
        height: 465px;
        overflow-y: scroll;
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 60px;
        letter-spacing: -1px;

        // :deep(span) {
        //     display: block;
        //     margin-bottom: 60px;
        // }
    }
    .confirm {
        margin: 85px auto 0;
        width: 440px;
        height: 88px;
        line-height: 88px;
        background-image: linear-gradient(0deg, #fa3374 0%, #fd578d 60%, #ff7aa5 100%), linear-gradient(#e59e20, #e59e20);
        background-blend-mode: normal, normal;
        border-radius: 44px;
        text-align: center;
        font-size: 36px;
        color: #ffffff;
    }
}
</style>
